export default {
	HeaderTitle: 'Resource management',
	PackageUse: 'Using package',
	InvoiceUsePackage: 'Invoices used',
	Invoice: 'Invoice',
	UseTo: 'Invoices used',
	InfoInvoice: 'Accumulated invoice information',
	TotalBought: 'Total purchased invoices:',
	TotalUsed: 'Total invoice used:',
	TotalStillUse: 'Total invoices are still in use:',
	HistoryResource: 'Resource purchasing history',
	OrderManager: 'Orders management',
	Resource: 'Resource management',
	OrderNotPayment: 'Order is not paid',
	OrderNewBuy: 'Buy a new order',
	ConfirmOrder: 'Order confirmation',
	HasCodeNew: "I've got a new activation code",
	UsedUpInvoice: 'Your invoice is out',
	Extension: 'Renew',
	PayNow: 'Buy now',
	PayAdd: 'Additional purchase',
	PurchaseInvoice: 'Purchased invoices',
	Used: 'Used',
	NotUsed: 'Not used',
	ExtensionNow: 'Renew now',
	ConfirmPaymentOrder: 'Payment confirmation',
	ContentTransaction: 'Contents of money transfer',
	AttachFolder: 'Add file attachment',
	Cancel: 'Cancel',
	ExpiredComingdDate: 'Your usage time is running out',
	ExpiredDate: 'Your usage time is expired',
	ExpiredCommingInvoice: 'Your usage invoice is running low',
	ExpiredInvoice: 'Your usage invoice is out',
	ExpiredCommingInvoiceDate: 'Your usage time and usage invoice are running out',
	ExpiredInvoiceDate: 'Your usage time and usage invoice are expired ',
	AllowUsed: 'Resources have been revoked',
	LicenseCommingDate: 'Your resources are running low',
	PaymentOrderUsing: 'You need to Renew/Additional purchase resources to continue using the software',
	LicenseExpiredDate: 'Your resources have run out',
	ConfirmPayment: {
		AlertFillCorrectContent:
			'Please enter the exact content of the money transfer stated in the Payment Authorization and attach a picture of the Payment Authorization for MISA to determine the payment',
		ImageConfirm: 'Photos of money transfer documents, spending authorizations,...',
		DragFileOrClick: 'Drag and drop files here or tap to',
		SelectFile: 'Select file',
		FromComputer: 'From a computer',
		AllowFile: 'Accepts jpg, png, jpeg files up to 5MB',
		ConfirmPay: 'Payment validation',
		ConfirmPaymentAccess: 'Confirm successful order payment'
	},
	Expried: {
		InvoiceOver: 'Your invoice is out',
		MessageResourceOver: {
			FirstText: 'Your resource expires on',
			SecondText: 'Make an extension',
			EndText: 'more time to continue processing invoices'
		},
		AlertBuyMoreInvoice: {
			FirstText: 'Please purchase additional invoices to continue using',
			EndText: 'e-invoice processing services'
		},
		BuyNow: 'Buy now'
	},
	OrderExistWarning: {
		DidNotPayment: 'Unpaid',
		AlertHaveOtherOrderToBuy: {
			FirstText: 'are you home',
			SecondText: 'unpaid',
			ThirdText: 'Please pay or cancel the above order before purchasing a new order',
			FourthText: 'Do you really want to cancel the order number?',
			EndText: 'to buy a new order?'
		},
		AlertHaveOtherOrderToActive: {
			FirstText: 'are you home',
			SecondText: 'unpaid',
			ThirdText: 'Please pay or cancel the above order before activating a new order',
			FourthText: 'Do you really want to cancel the order number?',
			EndText: 'to activate a new order?'
		}
	},
	OrderManagerPage: {
		OrderNo: 'Order No.',
		OrderDate: 'Booking date',
		TotalAmount: 'Amount',
		PaymentMethod: 'Payment method',
		PaymentStatus: 'Payment status',
		Paid: 'Paid',
		CancelPayment: 'Cancel payment'
	},
	PaymentDueWarning: {
		AlertActiveTaxCode: 'You enabled the tax code {taxCode} on the {startDate} and used',
		ExpireDate: 'MISA meInvoice - Processing invoices to date {expiredDate}',
		AlertNeedPaymentToUseAll: 'To fully access the service, you need to pay MISA order No.',
		OutOfDatePayment: 'Order is overdue',
		OutOfDateTryUseResource: 'Your trial resource has expired on the date',
		PleasePayment: 'Please pay to continue using'
	},
	ResourceHistory: {
		StartDate: 'Date of issue',
		ExpiredDate: 'Your usage time is expired',
		NumberOfInvoiceSum: 'Number of reinforcement plans',
		NumberOfInvoice: 'Invoice No.',
		Description: 'Description',
		InUse: 'In use',
		Used: 'Used'
	},
	Resources: {
		OrderNo: 'Order No.',
		PendingAllow: 'pending approval',
		ShowOrder: 'View order',
		Active: 'Active',
		BuyNow: 'Buy now',
		Extend: 'Renew',
		BuyMore: 'Additional purchase'
	},
	UsedUpWarning: {
		AlertResourceRunningOutSoon: {
			FirstText: 'Your resources are only valid',
			SecondText: 'date with',
			ThirdText: 'The remaining invoice. Please renew/buy more for uninterrupted use'
		},
		AlertOutOfResource: 'Your resources have run out. Please renew/buy more to continue using',
		ALertTimeRunningOutSoon: {
			FirstText: 'Your usage time is limited',
			SecondText: 'day',
			ThirdText: 'Please renew for uninterrupted use'
		},
		AlertTimeOut: 'Your usage time has expired. Please renew to continue using',
		AlertOrderRunningOutSoon: {
			FirstText: 'The number of invoices allowed to use you is only reduced',
			SecondText: 'invoice. Please buy more for uninterrupted use'
		},
		AlertOutOfOrder:
			'The number of invoices still allowed to be used has expired. Please buy more to continue using',
		AlertTrial: 'You have run out of resources by using trial. Make Buy Now to continue using'
	},
	WarningLicense: {
		Expired: "Your usage time has expired",
		ExpiredTrial: "Your trial period has expired.",
		OutOfQuantity: "Your invoice quantity has run out.",
		ExpiredAndQuantity: "Your usage time and invoice quantity have expired.",
		ExpiredAndQuantityTrial: "Your trial period and invoice quantity have expired.",
		Please: "Please",
		Extend: "extend",
		BuyMore: "buy more",
		WarningInterruption: "to avoid work interruption.",
		Update: "Please upgrade to the official version to avoid work interruption."
	}
};
